import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import Modal from 'shared/Modal';
import ResetPasswordForm from '../components/ResetPasswordForm';

import Home from './Home';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      token: props.match.params.token,
      forgotPasswordModalIsOpen: true
    };
  }

  handleResetPasswordModalClose() {
    this.setState({ forgotPasswordModalIsOpen: false }, () => {
      this.props.history.push('/');
    });
  }

  render () {
    const { token, forgotPasswordModalIsOpen } = this.state;

    return (
      <React.Fragment>
        <Home />

        { forgotPasswordModalIsOpen &&
          <Modal
            className="password-reset-modal"
            headerText="Reset Password"
            onModalClose={this.handleResetPasswordModalClose.bind(this)}
          >
            <ResetPasswordForm token={token} onPasswordReset={this.handleResetPasswordModalClose.bind(this)} />
          </Modal>
        }
      </React.Fragment>
    );
  }
}

ResetPassword.defaultProps = {};

ResetPassword.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default withRouter(ResetPassword);
